import { Scenario } from '@xplan-pension-switching/common';
import { ReactElement } from 'react';
import { TableColumn } from '@iress-oss/ids-components';
import { sortIdsComponent } from '../../../../helpers';

export type ScenarioTableRow = Scenario & {
    actionCell: ReactElement;
    scenarioCell: ReactElement;
    reportsCell: ReactElement;
    reportCount: number;
    createdByCell: string;
    lastModifiedCell: string;
};

export const scenarioTableColumns: Array<TableColumn<ScenarioTableRow>> = [
    {
        key: 'actionCell',
        label: '',
        format: 'string',
        sort: false,
    },
    {
        key: 'scenarioCell',
        label: 'Scenario',
        format: 'string',
        sortFn: (a, b): number => sortIdsComponent<ScenarioTableRow>('scenarioName', a.original, b.original),
    },
    {
        key: 'ownerClientType',
        label: 'Owner',
        format: 'string',
        sort: true,
    },

    {
        key: 'reportsCell',
        label: 'Reports',
        format: 'string',
        sort: true,
        sortFn: (a, b): number => sortIdsComponent<ScenarioTableRow>('reportCount', a.original, b.original),
    },
    {
        key: 'createdByCell',
        label: 'Created by',
        format: 'string',
        sort: true,
        sortFn: (a, b): number => sortIdsComponent<ScenarioTableRow>('createdBy', a.original, b.original),
    },
    {
        key: 'lastModifiedCell',
        label: 'Last modified',
        format: 'string',
        sort: true,
        sortFn: (a, b): number => sortIdsComponent<ScenarioTableRow>('modifiedDate', a.original, b.original),
    },
];
